export const FETCH_POLICIES_REQUEST = 'FETCH_POLICIES_REQUEST';
export const FETCH_POLICIES_SUCCESS = 'FETCH_POLICIES_SUCCESS';
export const FETCH_POLICIES_FAILURE = 'FETCH_POLICIES_FAILURE';

export const fetchPoliciesRequest = (params = {}) => ({ type: FETCH_POLICIES_REQUEST, payload: params });
export const fetchPoliciesSuccess = (data) => ({ type: FETCH_POLICIES_SUCCESS, payload: data });
export const fetchPoliciesFailure = (error) => ({ type: FETCH_POLICIES_FAILURE, payload: error });

export const FETCH_ACTIVITY_POLICY_BY_ID_REQUEST = 'FETCH_ACTIVITY_POLICY_BY_ID_REQUEST';
export const FETCH_ACTIVITY_POLICY_BY_ID_SUCCESS = 'FETCH_ACTIVITY_POLICY_BY_ID_SUCCESS';
export const FETCH_ACTIVITY_POLICY_BY_ID_FAILURE = 'FETCH_ACTIVITY_POLICY_BY_ID_FAILURE';

export const fetchActivityPolicyByIdRequest = (policyId) => ({ type: FETCH_ACTIVITY_POLICY_BY_ID_REQUEST, payload: policyId });
export const fetchActivityPolicyByIdSuccess = (data) => ({ type: FETCH_ACTIVITY_POLICY_BY_ID_SUCCESS, payload: data });
export const fetchActivityPolicyByIdFailure = (error) => ({ type: FETCH_ACTIVITY_POLICY_BY_ID_FAILURE, payload: error });

export const CHANGE_ACTIVITY_POLICY_STATUS_REQUEST = 'CHANGE_ACTIVITY_POLICY_STATUS_REQUEST';
export const CHANGE_ACTIVITY_POLICY_STATUS_SUCCESS = 'CHANGE_ACTIVITY_POLICY_STATUS_SUCCESS';
export const CHANGE_ACTIVITY_POLICY_STATUS_FAILURE = 'CHANGE_ACTIVITY_POLICY_STATUS_FAILURE';

export const changeActivityPolicyStatusRequest = (policyId, status) => ({ type: CHANGE_ACTIVITY_POLICY_STATUS_REQUEST, payload: { policyId, status } });
export const changeActivityPolicyStatusSuccess = (data) => ({ type: CHANGE_ACTIVITY_POLICY_STATUS_SUCCESS, payload: data });
export const changeActivityPolicyStatusFailure = (error) => ({ type: CHANGE_ACTIVITY_POLICY_STATUS_FAILURE, payload: error });

export const DELETE_ACTIVITY_POLICY_REQUEST = 'DELETE_ACTIVITY_POLICY_REQUEST';
export const DELETE_ACTIVITY_POLICY_SUCCESS = 'DELETE_ACTIVITY_POLICY_SUCCESS';
export const DELETE_ACTIVITY_POLICY_FAILURE = 'DELETE_ACTIVITY_POLICY_FAILURE';

export const deleteActivityPolicyRequest = (policyId) => ({ type: DELETE_ACTIVITY_POLICY_REQUEST, payload: policyId });
export const deleteActivityPolicySuccess = () => ({ type: DELETE_ACTIVITY_POLICY_SUCCESS });
export const deleteActivityPolicyFailure = (error) => ({ type: DELETE_ACTIVITY_POLICY_FAILURE, payload: error });



